import { DataBean } from "../DataBean";

export class AdquisitionItem extends DataBean {


    public IN_PREPARATION = 30;
    public PREPARED = 31;
    public CREATED = 3;
    public STRUCTURED = 4;
    public REVIEWED = 5;
    public APPROVED = 6;
    public REJECTED = 7;
    public CANCELLED = 8;
    public INCOMPLETED = 9;
    public VALUE_MISMATCH = 27;
    public IN_PRECONTRACTUAL = 40;
    public IN_CONTRACTET = 41;
    public IN_LIQUIDATE = 42;
    public IN_EDIT = 43;

    public async getAdquisitionItem(idAdquisitionItem: number): Promise<any> {
        return this.getCustomService("FinanceCore", "com.orange.bean.supplier.AdquisitionItem_getAdquisitionItem_Number", [idAdquisitionItem]);
    }

    public async getAdquisitionItemByProps(page: number, recordsPerPage: number, props: any): Promise<any> {
        return this.getCustomService("FinanceCore", "com.advantage.shared.Report_getAdquisitionItemByProps_Number_Number_java.util.Map", [page, recordsPerPage, props]);
    }

    public async getAdquisitionItemAprovedStateByPreparered(idAdquisitionPlanFunctionalID: number, idAccountPrepared: number): Promise<any> {
        return this.getCustomService("SupplierERP", "java.util.List_getAdquisitionItemAprovedStateByPreparered_Number_Number", [idAdquisitionPlanFunctionalID, idAccountPrepared]);
    }
    public async getOfferEmployeeCatalogRender(idAdquisitionItem: number): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getOfferEmployeeCatalogRender_Number", [idAdquisitionItem]);
    }
    public async getAdquisitionItemInboxProcessAssigned(rows: number, page: number, idEmployee: number): Promise<any> {
        return this.getCustomService("SupplierERP", "java.util.List_getAdquisitionItemInboxProcessAssigned_Number_Number_Number", [rows, page, idEmployee]);
    }
    public async getAdquisitionItemInboxProcessForManagement(rows: number, page: number, idEmployee: number): Promise<any> {
        return this.getCustomService("SupplierERP", "java.util.List_getAdquisitionItemInboxProcessForManagement_Number_Number_Number", [rows, page, idEmployee]);
    }
    public async getAdquisitionItemForPreviusEstudy(idAdquisitionItem: number): Promise<any> {
        return this.getCustomService("SupplierERP", "com.orange.bean.supplier.AdquisitionItem_getAdquisitionItemForPreviusEstudy_Number", [idAdquisitionItem]);
    }

    public async getAdquisitionItemByFuncionalID(idAdquisitionPlanFunctionalID: number, state: number, page: number, recordsPerPage: number): Promise<any> {
        return this.getCustomService("FinanceCore", "com.advantage.shared.Report_getAdquisitionItemByFuncionalID_Number_Number_Number_Number", [idAdquisitionPlanFunctionalID, state, page, recordsPerPage]);
    }
    public async getAdquisitionItemByFuncionalIDAndBudget(idAdquisitionPlanFunctionalID: number, budgetIDStr: string): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getAdquisitionItemByFuncionalIDAndBudget_Number_String", [idAdquisitionPlanFunctionalID, budgetIDStr]);
    }

    public async changeAdquisitionItemApprovalNote(idAdquisitionItem: number, idAccount: number, obs: string, state: number): Promise<any> {
        return this.getCustomService("FinanceCore", "com.orange.bean.supplier.AdquisitionItemApprovalNote_changeAdquisitionItemApprovalNote_Number_Number_String_Number", [idAdquisitionItem, idAccount, obs, state])
    }

    public async validateAdquisitionItem(idAdquisitionItem: number): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_validateAdquisitionItem_Number", [idAdquisitionItem])
    }
    public async getAdquisitionItemsByPlanAndBudgetCode(idAdquisitionPlan: number, budgetJsonCode: string | null): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getAdquisitionItemsByPlanAndBudgetCode_Number_String", [idAdquisitionPlan, budgetJsonCode])
    }
    public async getAdquisitionPlanFunctionalIDCatalog(idAdquisitionPlan: number): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getAdquisitionPlanFunctionalIDCatalog_Number", [idAdquisitionPlan])
    }
    public async getFunctionalIDByKey(idLn: number): Promise<any> {
        return this.getCustomService("OrangeBase", "com.orange.bean.functional.FunctionalID_getFunctionalIDByKey_Number", [idLn])
    }
    public async getAdquisitionPlanFunctionalID(idAdquisitionPlanFunctionalID: number): Promise<any> {
        return this.getCustomService("FinanceCore", "com.orange.bean.supplier.AdquisitionPlanFunctionalID_getAdquisitionPlanFunctionalID_Number", [idAdquisitionPlanFunctionalID])
    }
    public async getRequestAdquisitionItemRender(page: number, rows: number, properties: any): Promise<any> {
        return this.getCustomService("FinanceCore", "com.advantage.shared.Report_getRequestAdquisitionItemRender_Number_Number_java.util.Map", [page, rows, properties])
    }
    public async updateAdquisitionItem(bean: any): Promise<any> {
        return this.getCustomService("FinanceCore", "com.orange.bean.supplier.AdquisitionItem_updateAdquisitionItem_com.orange.bean.supplier.AdquisitionItem", [
            {
                DataBeanProperties: bean,
                DataBeanName: 'com.orange.bean.supplier.AdquisitionItem'
            }
        ])
    }
}